<script>
import lazyLoadComponent from '@router/lazyload-component'
import cloneDeep from 'lodash/cloneDeep'

const extraInfoPhone = {
  // type:'phone',
  phoneCode: '+886',
  phoneNumber: '',
}

const extraInfoEmergency = {
  // type:'emergency',
  phoneCode: '+886',
  phoneNumber: '',
  fullName: '',
  gender: 'male',
}

const initData = () => {
  return {
    fullName: '',
    gender: 'male',
    phone: '',
    phoneCode: '+886',
    phoneNumber: '',
    tags: [],
    email: '',
    lineId: '',
    merchantNote: '',
    extraInfos: {
      extraInfoPhone: [extraInfoPhone],
      extraInfoEmergency: [extraInfoEmergency],
    },
  }
}

export default {
  components: {
    CountryCodePicker: () => lazyLoadComponent(import('@components/CountryCodePicker')),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => {},
    },
    addMemberStatus: {
      type: Boolean,
      default: false,
    },
    isAutoOpen: {
      type: Boolean,
      default: false,
    },
    drawerOpenType: {
      type: Object,
      default: () => {
        return {
          autoOpenForGoodsAndMember: false, // 有會員&&自動開啟
          autoOpenForGoodsAndNonMember: false, // 無會員無訪客&&自動開啟
          autoOpenForGoodsAndVisit: false, // 訪客&&自動開啟
          normal: true, // 常態模式
        }
      },
    },
  },
  data() {
    return {
      submitData: Object.assign({}, initData()),
      tagList: [],
      tryingStoreMember: false,
      isEditingNationalId: false,
    }
  },
  computed: {
    isEditMode() {
      return !!this.defaultValue.id
    },
    submitRules() {
      const isTaiwan = this.submitData.phoneCode === '+886'
      // const isTaiwan = true
      return {
        fullName: [
          {
            required: true,
            message: '請輸入姓名',
          },
        ],
        phone: [
          {
            required: true,
            message: '請填寫手機號碼',
            trigger: 'blur',
          },
          {
            pattern: isTaiwan ? /^09\d{8}$/ : '',
            message: '格式請符合 09XXXXXXXX',
            trigger: 'blur',
          },
        ],
        gender: [
          {
            required: true,
            message: '請選擇性別',
            // trigger: 'change',
          },
        ],
        email: [
          {
            type: 'email',
            message: '請輸入正確的 Email 格式',
            trigger: 'blur',
          },
        ],
      }
    },
    filteredSubmitData() {
      const { tags, ...data } = this.submitData
      const tagIds = tags.map((item) => item.id)
      return {
        ...data,
        tagIds,
      }
    },
    maskedNationalId() {
      if (this.submitData.extraInfos.nationalId) {
        const id = this.submitData.extraInfos.nationalId

        const firstChar = id.charAt(0).toUpperCase()
        const maskedMiddle = '******'
        const lastThree = id.slice(-3)
        return firstChar + maskedMiddle + lastThree
      }
      return ''
    },
  },
  watch: {
    defaultValue: {
      handler(val) {
        // 保存當前輸入的 nationalId
        const currentNationalId = this.submitData.extraInfos?.nationalId || ''

        this.submitData = cloneDeep({
          ...initData(),
          ...val,
          phone: val.phoneNumber || '',
          merchantNote: val.merchantNote ? val.merchantNote.replace(/<br\s\/>/g, '') : '',
          extraInfos: {
            extraInfoPhone: [extraInfoPhone],
            extraInfoEmergency: [extraInfoEmergency],
            nationalId: currentNationalId, // 保留用戶輸入的內容
            ...(val.extraInfos || {}), // 再覆蓋其他字段
          },
        })
      },
      immediate: true,
    },
  },
  created() {
    this.tryToFetchTagList()
  },
  methods: {
    async tryToFetchTagList(search) {
      this.tagList = await this.$store.dispatch('member/fetchTags', {
        search,
      })
    },
    generateTaiwanMobileNumber() {
      const prefixes = ['09']
      const prefix = prefixes[Math.floor(Math.random() * prefixes.length)]

      let phoneNumber = prefix

      // 產生 8 位數字
      for (let i = 0; i < 8; i++) {
        phoneNumber += Math.floor(Math.random() * 10)
      }
      return phoneNumber
    },
    /**
     * @description 創造假會員資料
     */
    async createFakeMember() {
      for (let i = 0, len = 500; i <= len; i++) {
        setTimeout(async () => {
          const fakeNumber = this.generateTaiwanMobileNumber()
          this.filteredSubmitData.fullName = `fake-${i}`
          this.filteredSubmitData.phone = fakeNumber
          this.filteredSubmitData.phoneNumber = fakeNumber
          await this.$store.dispatch('member/store', this.filteredSubmitData)
        }, i * 500)
      }
    },
    /**
     * @description 新增會員儲存按鈕
     */
    async tryToStoreMember() {
      // await this.createFakeMember()
      // return
      // 如果要創建假資料，要打開上面兩行
      await this.$refs.form.validate()
      try {
        const { items = {} } = await this.$store.dispatch('member/store', this.decideSubmitData())
        const memberId = items.id || this.defaultValue.id

        const updateMemberInfoView = () => {
          this.$emit('update', memberId)
        }

        updateMemberInfoView()
        this.$emit('releaseMemberPhoneDisable') // 解除新增會員的disable
        this.$message({ message: '儲存成功', type: 'success' })
        this.$emit('showMemberInfo')
      } finally {
        this.tryingStoreMember = false
      }
    },
    /**
     * @description 決定submitData資料
     */
    decideSubmitData() {
      // 使用者手動點開＋一般normal 會員顯示
      if (!this.isAutoOpen && this.drawerOpenType.normal) {
        console.log(cloneDeep(this.filteredSubmitData))
        return cloneDeep(this.filteredSubmitData)
      }
      // 自動跳出視窗，autoOpenForGoodsAndNonMember => 非會員的新增
      if (this.isAutoOpen && this.drawerOpenType.autoOpenForGoodsAndNonMember) {
        console.log(Object.assign({}, cloneDeep(this.filteredSubmitData), { phoneNumber: this.filteredSubmitData.phone }))
        return Object.assign({}, cloneDeep(this.filteredSubmitData), { phoneNumber: this.filteredSubmitData.phone })
      }
    },
    /**
     * @description 新增會員時的取消按鈕
     */
    onClickClose() {
      this.$emit('releaseMemberPhoneDisable') // 解除新增會員的disable
      this.$emit('close')
    },
    reInputNationalId() {
      // 切換到重新輸入模式，並清空舊資料
      this.isEditingNationalId = true
      this.submitData.extraInfos.nationalId = ''
    },
    toUpperCase(val) {
      this.submitData.extraInfos.nationalId = val.toUpperCase()
    },
  },
}
</script>
<template>
  <div :class="$style.orderformSection">
    <div class="orderformSection__right__header">
      <button class="el-drawer__close-btn" aria-label="close drawer" type="button" @click="onClickClose"><i class="el-dialog__close el-icon el-icon-close"></i></button>
      <h4 class="orderformSection__right__title">{{ isEditMode ? '編輯客戶資訊' : '新增客戶' }}</h4>
    </div>
    <div class="orderformSection__right__content">
      <el-form ref="form" :model="submitData" :rules="submitRules" label-position="top" class="el-form-item--normal-margin el-form-item--white-bg">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="fullName" label="姓名" class="el-form-item--normal-margin">
              <el-input v-model="submitData.fullName" placeholder="請輸入姓名" class="is-border"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="el-form-item--normal-margin gender-box" prop="gender">
              <el-radio-group v-model="submitData.gender" class="no-bg-radio-group">
                <el-radio label="male">先生</el-radio>
                <el-radio label="female">小姐</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="phone" label="電話" class="el-form-item--normal-margin">
              <el-input v-model.trim="submitData.phone" placeholder="請輸入手機號碼" :disabled="isEditMode || addMemberStatus">
                <CountryCodePicker slot="prepend" v-model="submitData.phoneCode" :disabled="isEditMode" />
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="備用電話" class="el-form-item--normal-margin">
              <el-input v-model.trim="submitData.extraInfos.extraInfoPhone[0].phoneNumber" placeholder="請輸入備用電話">
                <CountryCodePicker slot="prepend" v-model="submitData.extraInfos.extraInfoPhone[0].phoneCode" />
              </el-input>
            </el-form-item>
          </el-col>
          <!-- 身分證號碼第一次輸入明碼 如果後端有資料就顯示暗碼 -->
          <el-col :span="24">
            <el-form-item label="身份證字號" class="el-form-item--normal-margin">
              <template v-if="!isEditingNationalId">
                <!-- 顯示遮蔽字串，禁止編輯 -->
                <el-input :value="maskedNationalId" disabled> </el-input>
                <el-button type="text" @click="reInputNationalId">重新輸入</el-button>
              </template>

              <template v-else>
                <!-- 重新輸入時，欄位清空 -->
                <el-input v-model.trim="submitData.extraInfos.nationalId" @input="toUpperCase" placeholder="請輸入身份證字號" maxlength="10" show-word-limit />
              </template>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="標籤" class="el-form-item--normal-margin">
              <el-select v-model="submitData.tags" value-key="id" multiple placeholder="請選擇">
                <el-option v-for="tag in tagList" :key="tag.id" :label="tag.title" :value="tag"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="Email" prop="email">
              <el-input v-model="submitData.email" placeholder="Email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="LINE ID">
              <el-input v-model="submitData.lineId" placeholder="LINE ID"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="緊急聯絡人姓名" class="el-form-item--normal-margin">
              <el-input v-model="submitData.extraInfos.extraInfoEmergency[0].fullName" placeholder="請輸入姓名"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item class="el-form-item--normal-margin gender-box">
              <el-radio-group v-model="submitData.extraInfos.extraInfoEmergency[0].gender" class="no-bg-radio-group">
                <el-radio label="male">先生</el-radio>
                <el-radio label="female">小姐</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="緊急聯絡人電話" class="el-form-item--normal-margin">
              <el-input v-model.trim="submitData.extraInfos.extraInfoEmergency[0].phoneNumber" placeholder="請輸入緊急聯絡人電話">
                <CountryCodePicker slot="prepend" v-model="submitData.extraInfos.extraInfoEmergency[0].phoneCode" />
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="btn-group-inline" style="padding: 30px 0 50px">
          <el-button plain class="is-round" @click="onClickClose">取消</el-button>
          <el-button :loading="tryingStoreMember" class="is-round" type="primary" @click="tryToStoreMember">儲存</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>
<style lang="scss" module>

.orderformSection {
  :global {
    .orderformSection {
      &__right {
        position: relative;
        width: 43%;
        height: calc(100vh);
        overflow: hidden;

        .orderformSection__right__header {
          background-color: $color-line;
          z-index: 999;
        }

        &__title {
          margin: 0;
          padding: 19px 0;
          padding-left: 50px;
        }

        &__header {
          position: relative;
          border-bottom: $color-border-base 1px solid;

          .el-drawer__close-btn {
            // font-weight: 300;
            color: #72767b;
            position: absolute;
            padding: 15px;
            border: 0;
            left: 0;
            top: 3px;
          }

          .el-tabs__item {
            height: auto;
            padding: 10px 0;
          }

          .el-tabs__nav-wrap::after {
            display: none;
          }

          .el-tabs__header {
            margin-bottom: 0;
          }

          .el-tabs--top {
            margin-left: 60px;

            @include max-lg {
              margin-left: 30px;
            }
          }
        }

        &__content {
          z-index: 10;
          height: calc(100vh - 60px);
          overflow: auto;
          padding: 30px;
          padding-bottom: 120px;
          position: relative;
          background-color: $color-line;

          @include max-lg {
            padding: 20px;
          }
        }
      }
    }
  }
}
</style>
